import React from 'react';

import ButtonLink from '@dashboard/components/mui-atoms/ButtonLink';
import IconButtonLink from '@dashboard/components/mui-atoms/IconButtonLink';
import { Box, Button, IconButton } from '@mui/material';

type Props = {
  color?: string;
};

function WaypointGlyph({ color = 'white' }: Props): JsxNode {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5556 9.70733L19.5554 0.916687H10.867V2.98507H17.5374V9.49599L15.1011 12.0499L15.0959 5.57172L6.35018 5.57054V7.63892H12.9971V14.2557L10.4746 16.9V10.2244H1.83334V12.2928H8.45672V19.0162L8.45703 19.0159L8.45706 21.0834L19.5556 9.70733Z"
        fill={color}
      />
    </svg>
  );
}

function WaypointLogo({ color = 'white' }: Props): JsxNode {
  return (
    <svg width="107" height="12" viewBox="0 0 107 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.27443 12.0001L7.98643 5.88806C8.35443 4.57606 8.37043 3.64806 8.38643 2.59206H9.18643C9.18643 3.64806 9.21843 4.56006 9.57043 5.88806L11.1864 12.0001H13.6184L16.6264 0.800058H14.4344L13.2344 6.00006C12.9144 7.39206 12.8824 8.76806 12.8824 10.0641H12.0824C12.0504 8.99206 12.0024 7.93606 11.7304 6.92806L10.1144 0.800058H7.45843L5.85843 6.67206C5.52243 7.90406 5.47443 9.00806 5.45843 10.0641H4.65843C4.64243 8.78406 4.62643 7.44006 4.32243 6.01606L3.15443 0.800058H0.914429L3.79443 12.0001H6.27443Z"
        fill={color}
      />
      <path
        d="M30.2424 12.0001L26.0504 0.800058H23.2984L19.0424 12.0001H21.2824L22.2584 9.23206H26.9624L27.9224 12.0001H30.2424ZM23.8424 4.76806C24.1464 3.93606 24.2264 3.18406 24.2424 2.06406H25.0264C25.0424 3.18406 25.1384 3.93606 25.4104 4.75206L26.3384 7.44006H22.8984L23.8424 4.76806Z"
        fill={color}
      />
      <path
        d="M38.0258 12.0001V7.36006L41.9938 0.800058H39.6098L38.1858 3.36006C37.5298 4.54406 37.4338 5.31206 37.4018 6.36806H36.6178C36.6018 5.31206 36.5218 4.54406 35.8498 3.39206L34.3138 0.800058H31.8818L35.9458 7.39206V12.0001H38.0258Z"
        fill={color}
      />
      <path
        d="M48.2188 12.0001V7.88806H50.9548C53.3388 7.88806 54.8748 6.46406 54.8748 4.32006C54.8748 2.19206 53.3388 0.800058 50.9548 0.800058H46.1388V12.0001H48.2188ZM48.2188 2.59206H50.5708C51.9148 2.59206 52.6988 3.26406 52.6988 4.32006C52.6988 5.42406 51.8988 6.12806 50.5708 6.12806H48.2188V2.59206Z"
        fill={color}
      />
      <path
        d="M64.2678 12.2401C67.8038 12.2401 70.0918 9.84006 70.0918 6.41606C70.0918 3.02406 67.7878 0.560059 64.2678 0.560059C60.7638 0.560059 58.4278 3.02406 58.4278 6.41606C58.4278 9.84006 60.7158 12.2401 64.2678 12.2401ZM64.2678 10.4641C61.9638 10.4641 60.6198 8.73606 60.6198 6.41606C60.6198 4.06406 61.9638 2.33606 64.2678 2.33606C66.5558 2.33606 67.8998 4.06406 67.8998 6.41606C67.8998 8.73606 66.5558 10.4641 64.2678 10.4641Z"
        fill={color}
      />
      <path d="M76.7532 12.0001V0.800058H74.6732V12.0001H76.7532Z" fill={color} />
      <path
        d="M84.1219 12.0001V6.27206C84.1219 4.59206 83.7379 3.64806 83.2099 2.64006L83.8819 2.22406L89.8819 12.0001H92.4099V0.800058H90.3299V5.74406C90.3299 7.32806 90.5539 7.93606 91.2419 9.05606L90.5859 9.52006L85.2419 0.800058H82.0419V12.0001H84.1219Z"
        fill={color}
      />
      <path d="M102.395 12.0001V2.59206H106.347V0.800058H96.4272V2.59206H100.315V12.0001H102.395Z" fill={color} />
    </svg>
  );
}

export function WhiteWaypointLogo() {
  return (
    <Box>
      <IconButtonLink href="/" sx={{ display: { xs: 'inline-flex', sm: 'none' } }}>
        <WaypointGlyph color="#FFF" />
      </IconButtonLink>
      <ButtonLink href="/" sx={{ ml: -1, display: { xs: 'none', sm: 'inline-flex' } }}>
        <WaypointLogo color="#FFF" />
      </ButtonLink>
    </Box>
  );
}

export function ErrorPageWhiteWaypointLogo() {
  return (
    <Box>
      <IconButton href="/" sx={{ display: { xs: 'inline-flex', sm: 'none' } }}>
        <WaypointGlyph color="#FFF" />
      </IconButton>
      <Button href="/" sx={{ ml: -1, display: { xs: 'none', sm: 'inline-flex' } }}>
        <WaypointLogo color="#FFF" />
      </Button>
    </Box>
  );
}
